import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Vuelidate from 'vuelidate'
import {
  toJalaali
} from './functions/myDate'
import myAxios from './functions/myAxios'
import VCurrencyField from 'v-currency-field'
//
import {
  VTextField
} from 'vuetify/lib' //Globally import VTextField
Vue.component('v-text-field', VTextField)
//
Vue.use(Vuelidate)
Vue.use(VCurrencyField, {
  locale: 'en-US',
  decimalLength: 0,
  autoDecimalMode: false,
  min: 0,
  max: 1000000000000,
  defaultValue: 0,
  valueAsInteger: true,
  allowNegative: false
})
//
import {
  VueMaskDirective
} from 'v-mask'
Vue.directive('mask', VueMaskDirective)
//
Vue.use(require('vue-shortkey'))
//
Vue.filter('currencyDisplay', function(value) {
  let val = (value / 1).toFixed(0) //.replace('.', ',')
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") //"."
  // return new Intl.NumberFormat('fa-IR').format(val);
})
Vue.filter('valueDisplay', function(val) {
  if (!val)
    return 0
  if (val > 0) {
    val = parseFloat(Number(val).toFixed(4)).toLocaleString('en')
    return String(val).replace(/\./g, '/');
  }
});
Vue.filter('noneAbsDoubleDisplay', function(num) {
  let _return;
  if (!num || 0) {
    return 0
  } else {
    // _return = num.toFixed(4);
    _return = parseFloat(Number(num).toFixed(4))
    // _return = Number(_return).toLocaleString('en')
    _return = String(_return).replace('.', '/')
    return _return
  }
});
//
Vue.mixin({
  methods: {
    async personBalance(person_id, type) {
      //
      try {
        //
        let res = await myAxios({
          method: 'get',
          url: `/api/persons/${type}`,
          params: {
            mid: person_id
          }
        });

        if (res && res.data) {
          // console.log(res.data);
          // return res.data[0].balance
          return res.data
        } else {
          return 0;
        }
      } catch (err) {
        console.log(err);
        return;
      }
    },
    myDateTime: function() {
      return toJalaali(new Date())
    },
    getNewId() {
      return (+new Date() + Math.floor(Math.random() * 999999)).toString(36);
    },
    doubleDisplay(num) {
      let _return;
      if (!num || 0) {
        return 0
      } else {
        // _return = Math.abs(num);
        _return = Math.abs(num.toFixed(4));
        _return = Number(_return).toLocaleString('en');
        _return = String(_return).replace('.', '/');
        return _return
      }
    },
    noneAbsDoubleDisplay: function(num) {
      let _return;
      if (!num || 0) {
        return 0
      } else {
        _return = Number(num).toFixed(4);
        _return = Number(_return).toLocaleString('en');
        _return = String(_return).replace('.', '/');
        return _return
      }
    },
    currencyDisplay: function(val) {
      if (!val || 0) {
        return 0
      } else {
        val = Number(val).toFixed(0);
        console.log(val);
        return Number(Math.round(val + 'e3') + 'e-3').toLocaleString('en')
        // return Number(val).toLocaleString('en');
      }
    },
    rmCamma: function(val) {
      let ret = String(val).replace('/', '')
      return Number(String(ret).replace(/,/g, ''))
    },
    round: function(value, decimals) {
      return Number(Math.round(this.rmCamma(value) + 'e' + decimals) + 'e-' + decimals) || 0
    },
  },
})
//
Vue.config.productionTip = false
//
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
